var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Input from 'components/Input.vue';
import Tooltip from 'components/Tooltip.vue';
import { escapeRegExp, groupBy } from 'lodash';
import { copyToClipboard } from 'quasar';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { getApiUrl } from '@/shared/utils/helpers';
let CompanyDrawerDecisorsTab = class CompanyDrawerDecisorsTab extends Vue {
    constructor() {
        super(...arguments);
        this.loading = true;
        this.categories = {};
        this.tabs = [];
        this.currentIndexDecisors = null;
        this.filteredDecisors = [];
        this.clickCopyItem = false;
        this.itemCopiedIndex = -1;
        this.failedCopyItem = false;
        this.search = '';
        this.levels = [
            { label: 'Alto', checked: true, queryField: 'level' },
            { label: 'Médio', checked: true, queryField: 'level' },
            { label: 'Baixo', checked: false, queryField: 'level' },
            { label: 'Não classificado', checked: false, queryField: 'level' },
        ];
        this.decisorsWith = [
            { label: 'Linkedin', checked: false, queryField: 'linkedin' },
            { label: 'E-mail', checked: false, queryField: 'email' },
        ];
        this.filterDecisorAreaFor = [
            { label: 'Administrativo', checked: false, queryField: 'department' },
            { label: 'Comercial', checked: false, queryField: 'department' },
            { label: 'Financeiro', checked: false, queryField: 'department' },
            { label: 'Gestão', checked: false, queryField: 'department' },
            { label: 'Industrial', checked: false, queryField: 'department' },
            { label: 'Jurídico', checked: false, queryField: 'department' },
            { label: 'Marketing', checked: false, queryField: 'department' },
            { label: 'Proprietários', checked: false, queryField: 'department' },
            { label: 'Recursos Humanos', checked: false, queryField: 'department' },
            { label: 'Suprimento', checked: false, queryField: 'department' },
            { label: 'TI', checked: false, queryField: 'department' },
            { label: 'Operacional', checked: false, queryField: 'department' },
            { label: 'Outros', checked: false, queryField: 'department' },
        ];
        this.filtersToogle = false;
    }
    get toolTipBgColor() {
        return `
      background-color: #9EB3DC
    `;
    }
    get successToolTipBgColor() {
        return `
      background-color: #99CA3C
    `;
    }
    get selected() {
        return (this.decisorsWith
            //@ts-ignore
            .concat(this.levels)
            //@ts-ignore
            .concat(this.filterDecisorAreaFor)
            .filter(l => l.checked === true)
            .map(l => ({ label: l.label, queryField: l.queryField })));
    }
    buildTabs() {
        this.categories = groupBy(this.filteredDecisors, 'department');
        this.tabs = Object.entries(this.categories);
    }
    onShowDepartmentPanel(index) {
        this.currentIndexDecisors = index;
    }
    onHideDepartmentPanel(index) {
        if (index === this.currentIndexDecisors) {
            this.currentIndexDecisors = null;
        }
    }
    clickToCopy(value, index) {
        this.clickCopyItem = true;
        this.itemCopiedIndex = index;
        copyToClipboard(value)
            .then(r => {
            setTimeout(() => {
                this.clickCopyItem = false;
                this.itemCopiedIndex = -1;
            }, 1000);
        })
            .catch(r => {
            setTimeout(() => {
                this.clickCopyItem = false;
                this.failedCopyItem = true;
                this.itemCopiedIndex = -1;
            }, 1000);
        });
    }
    openFilterMenu() {
        return (this.filtersToogle = !this.filtersToogle);
    }
    mounted() {
        this.fetchDecisors();
    }
    getSelectedItem(item) {
        return Object.values(this.selected)
            .map(s => s.label)
            .includes(item);
    }
    changedLevels() {
        this.fetchDecisors();
    }
    changedDepartments() {
        this.fetchDecisors();
    }
    changedWith() {
        this.fetchDecisors();
    }
    changedSearch() {
        this.fetchDecisors();
    }
    async fetchDecisors() {
        this.loading = true;
        try {
            const params = {
                with: this.decisorsWith.filter(l => l.checked).map(l => l.label),
                levels: this.levels.filter(l => l.checked).map(l => l.label),
                departments: this.filterDecisorAreaFor
                    .filter(l => l.checked)
                    .map(l => l.label),
                name: escapeRegExp(this.search),
            };
            const cnpj = this.cnpj.replace(/\D/g, '');
            const base_api = getApiUrl('v4');
            const response = await Vue.axios.post(`${base_api}/companies/${cnpj}/decisors?skip_handle_error`, params);
            this.filteredDecisors = response.data.data;
            this.buildTabs();
        }
        catch (err) {
            console.log(err);
        }
        this.loading = false;
    }
};
__decorate([
    Prop({ default: () => '' })
], CompanyDrawerDecisorsTab.prototype, "cnpj", void 0);
__decorate([
    Watch('levels', { deep: true })
], CompanyDrawerDecisorsTab.prototype, "changedLevels", null);
__decorate([
    Watch('filterDecisorAreaFor', { deep: true })
], CompanyDrawerDecisorsTab.prototype, "changedDepartments", null);
__decorate([
    Watch('decisorsWith', { deep: true })
], CompanyDrawerDecisorsTab.prototype, "changedWith", null);
__decorate([
    Watch('search', { deep: true })
], CompanyDrawerDecisorsTab.prototype, "changedSearch", null);
CompanyDrawerDecisorsTab = __decorate([
    Component({
        name: 'CompanyDrawerDecisorsTab',
        components: { Input, Tooltip },
    })
], CompanyDrawerDecisorsTab);
export default CompanyDrawerDecisorsTab;
